import { useMemo, useCallback } from "react";
import { useSearchParams } from "react-router-dom";
import { SORT_OPTIONS } from "../constants/sortOptions";
import { DEFAULT_SORT_PARAM } from "app/constants";

export const useSortParam = ({
	param = DEFAULT_SORT_PARAM,
	defaultValue = "recommendation",
	replaceByDefault = true,
	sortOptions = SORT_OPTIONS, // custom sort options based on the product type
}) => {
	const [searchParams, setSearchParams] = useSearchParams();

	const allowedOptions = sortOptions?.map(option => option.id) ?? [];
	const current = searchParams.get(param);

	const sortBy = useMemo(() => {
		return allowedOptions.includes(current) ? current : defaultValue;
	}, [current, allowedOptions, defaultValue]);

	const setSortBy = useCallback(
		(next, options = {}) => {
			const params = new URLSearchParams(searchParams);
			const value = allowedOptions.includes(next) ? next : defaultValue;

			if (value === defaultValue) {
				params.delete(param);
			} else {
				params.set(param, value);
			}

			setSearchParams(params, { replace: options.replace ?? replaceByDefault });
		},
		[allowedOptions, defaultValue, param, searchParams, setSearchParams, replaceByDefault]
	);

	return { sortBy, setSortBy };
};
